/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ticket_State_Closed_BannerInputs */

const en_ticket_state_closed_banner = /** @type {(inputs: Ticket_State_Closed_BannerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This ticket is closed. No further actions can be performed.`)
};

const ja_ticket_state_closed_banner = /** @type {(inputs: Ticket_State_Closed_BannerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`このチケットは閉じています。これ以上のアクションは実行できません。`)
};

const fr_ticket_state_closed_banner = /** @type {(inputs: Ticket_State_Closed_BannerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ce ticket est clôturé. Aucune action supplémentaire n'est possible.`)
};

const de_ticket_state_closed_banner = /** @type {(inputs: Ticket_State_Closed_BannerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dieses Ticket ist geschlossen. Es können keine Aktionen mehr ausgeführt werden.`)
};

/**
* | output |
* | --- |
* | "This ticket is closed. No further actions can be performed." |
*
* @param {Ticket_State_Closed_BannerInputs} inputs
* @param {{ locale?: "en" | "ja" | "fr" | "de" }} options
* @returns {LocalizedString}
*/
export const ticket_state_closed_banner = /** @type {((inputs?: Ticket_State_Closed_BannerInputs, options?: { locale?: "en" | "ja" | "fr" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ticket_State_Closed_BannerInputs, { locale?: "en" | "ja" | "fr" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ticket_state_closed_banner(inputs)
	if (locale === "ja") return ja_ticket_state_closed_banner(inputs)
	if (locale === "fr") return fr_ticket_state_closed_banner(inputs)
	return de_ticket_state_closed_banner(inputs)
});